import {Component, OnInit} from '@angular/core';
import {SideMenuComponent} from './side-menu/side-menu.component';
import {ActivatedRoute, Router, RouterOutlet} from '@angular/router';
import {CommunitySvgSprite} from './community-svg-sprite.component';

@Component({
  selector: 'community',
  templateUrl: './community.component.html',
  styleUrls: ['./community.component.scss'],
  standalone: true,
  imports: [SideMenuComponent, RouterOutlet ,CommunitySvgSprite]
})
export class CommunityComponent implements OnInit {

  totalRooms: number = 0;

  constructor(
    private route: ActivatedRoute,
    ) {

  }

  ngOnInit() {

    this.route.data.subscribe(data => {
      this.totalRooms = data.rooms.length;
    });

  }

}
